// Before implementing this, you'll need to contact Shopify support and ask them to turn off Google's ReCaptcha
// for your Shopify store's contact forms. Otherwise, it will redirect to the captcha's verification page.
// I'd recommend replacing it with a custom solution like this: https://captcha.cremadesignstudio.com/


function initContactForm(selector) {
	selector = selector || '.contact-form';

	document.querySelectorAll(selector).forEach(function (form) {

		const action = 'https://' + Shopify.shop + form.getAttribute("data-action"),
			alert = form.closest('.dialog').querySelector('[data-alert="status"]'),
			inputs = form.querySelectorAll("[name]");

		// Submit data via Fetch
		form.addEventListener('validation-submit', function (e) {
			form.closest('.dialog').classList.add('notification');
			fetch(action, {...fetchConfig(),
				mode: 'no-cors',
				body: getUrlString(formToJSON(inputs))
			}).then(function (response) {
				form.closest('.dialog').classList.add('notification');
				alert.className = "dialog__notification alert-success";
				alert.innerHTML = window.formString.contact_success;
				setTimeout(() => { resetForm(form) }, 3000);
			}).catch(function (error) {
				form.closest('.dialog').classList.add('notification');
				alert.className = "dialog__notification alert-danger";
				alert.innerHTML = window.formString.post_error;
			});
		});
	});
}

function resetForm(selector) {
	selector.closest('.dialog').classList.remove('notification');
	window.dispatchEvent(new CustomEvent('dialog-close'));
	selector.reset();
	const alert = selector.closest('.dialog').querySelector('[data-alert="status"]');
	alert.innerHTML = '';
}

